import SingleContactTicket from "@/components/CommonUi/SingleContactTicket";
import {
  clearContact,
  loadSingleContact,
} from "@/redux/rtk/features/CRM/contact/contactSlice";
import { loadAllTicketByContact } from "@/redux/rtk/features/CRM/ticket/ticketSlice";
import Tabs, { Tab } from "@/UI/Tabs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ContactProfile from "./ContactProfile";
import DetailsInfo from "./DetailsInfo";
// Import React Icons
import {
  FiTag,
  FiUser,
} from "react-icons/fi";

export default function DetailsContact() {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { contact, loading: contactLoading } = useSelector(
    (state) => state.contact
  );
  const { list: ticketList, loading: ticketLoading } = useSelector(
    (state) => state.ticket
  );

  useEffect(() => {
    dispatch(loadSingleContact(id));
    return () => {
      clearContact();
    };
  }, [dispatch, id]);

  return (
    <div className="w-full">
      <div className="flex flex-col w-full p-3 gap-6">
        <div className="text-xl font-semibold dark:text-white">
          {t("contact.contactDetails")}
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg">
          <Tabs className="contact-details-tabs ">
            <Tab label={t("contact.contactInformation") || "Contact Information"} icon={<FiUser />}>
              <div className="pt-4">
                <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 lg:gap-6">
                  <div className="xl:col-span-1 order-2 xl:order-1">
                    <ContactProfile
                      contact={contact}
                      contactLoading={contactLoading}
                    />
                  </div>
                  <div className="xl:col-span-2 order-1 xl:order-2">
                    <DetailsInfo
                      contact={contact}
                      contactLoading={contactLoading}
                    />
                  </div>
                </div>
              </div>
            </Tab>

            <Tab label={t("navigation.ticket")} icon={<FiTag />}>
              <div className="pt-4">
                <SingleContactTicket
                  contactId={id}
                  data={ticketList}
                  loading={ticketLoading}
                  name={"contactId"}
                  singleLoadThunk={loadAllTicketByContact}
                />
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
